<template>
  <div id="ticketManage">

    <custom-table ref="customTable" has-organization="true" :customOptions="customOptions" :columns="columns" addText="票据入库" @addFn="addFn" maxHeight="650">
      <template slot="table-operation">
        <el-table-column label="操作" width="100" fixed="right">
          <div slot-scope="{row}" class="custom-action">
            <el-button type="text" size="small" @click="deleteClick(row)">删除</el-button>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{item, row}">
        <div v-if="item.prop == 'created'">{{ row.created | filterTime }}</div>
        <span v-else>{{ row[item.prop] }}</span>
      </template>
    </custom-table>

    <!-- 入库 -->
    <el-dialog :visible.sync="dialogVisible" title="票据入库" @close="$refs.form.resetFields();" width="30%">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="机构名称" prop="organizationId">
          <el-select :disabled="form.id ? true : false" v-model="form.organizationId" filterable v-if="mixinUserInfo && mixinUserInfo.organizationType == 1">
            <el-option v-for="(item, i) in organizations" :key="i" :value="item.id" :label="item.name">
            </el-option>
          </el-select>
          <span v-else>{{ organizations && organizations[0] && organizations[0].name }}</span>
        </el-form-item>

        <el-form-item label="开始票号" prop="ticketStartNo">
          <el-input v-model="form.ticketStartNo" @input="form.ticketStartNo = form.ticketStartNo.replace(/[^\d]/g, '');$refs.form.validateField('ticketEndNo')" maxlength="15"></el-input>
        </el-form-item>
        <el-form-item label="结束票号" prop="ticketEndNo">
          <el-input v-model="form.ticketEndNo" @input="form.ticketEndNo = form.ticketEndNo.replace(/[^\d]/g, '')" maxlength="15"></el-input>
        </el-form-item>
        <el-form-item label="入库张数">
          <el-input :value="remainingNum" disabled></el-input>
        </el-form-item>
        <el-form-item label="剩余张数">
          <el-input v-model="remainingNum" disabled></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item style="margin-top: 50px; text-align: right;">
          <el-button @click=" dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveClick" :loading="loading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: "ticketManage",
  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: '/api/v1/manage/ticket/storage',
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          { type: "input", field: "ticketStartNo", name: "开始票号", value: "" },
          { type: "input", field: "ticketEndNo", name: "结束票号", value: "" },
          { type: "input", field: "adminName", name: "入库员", value: "" },
          {
            type: "select",
            field: "remainingNumFlag",
            name: "库存",
            value: "1",
            option: [
            { label: '有库存', value: '1' },
            { label: '无库存', value: '2' }
            ],
          },
        ]
      },
      columns: [
        { prop: 'ticketStartNo', label: '开始票号' },
        { prop: 'ticketEndNo', label: '结束票号' },
        { prop: 'ticketCurrentNo', label: '当前票号' },
        { prop: 'storageNum', label: '入库张数' },
        { prop: 'remainingNum', label: '剩余张数' },
        { prop: 'created', label: '入库时间', width: 150 },
        { prop: 'adminName', label: '入库员' },
        { prop: 'remark', label: '备注' },
      ],

      dialogVisible: false,
      organizationList: [],
      form: { organizationId: null, ticketStartNo: null, ticketCurrentNo: null, remark: null },
      rules: {
        organizationId: [{ required: true, message: '请选择机构名称' }],
        ticketStartNo: [{ required: true, message: '请输入开始票号' }],
        ticketEndNo: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('请输入结束票号'))
            } else if (String(this.form.ticketStartNo).length != String(value).length) {
              callback(new Error('开始票号和结束票号的长度不一致'))
            } else if (this.form.ticketStartNo > value) {
              callback(new Error('结束票号不能小于开始票号'))
            } else {
              callback()
            }
          }
        }]
      },
      loading: false,

    }
  },
  computed: {
    remainingNum() {
      if (String(this.form.ticketStartNo).length == String(this.form.ticketEndNo).length && this.form.ticketStartNo <= this.form.ticketEndNo) {
        return this.form.ticketEndNo - this.form.ticketStartNo + 1
      } else {
        return null;
      }
    },
  },
  async created() {
    await this.mixinOrganizations()
    this.getOrganizationList()
    if (!this.id && this.mixinUserInfo && this.mixinUserInfo.organizationType == 2) {
      if (this.organizations && this.organizations[0] && this.organizations[0].id) {
        this.organizationId = this.organizations[0].id
      }
    }
  },
  methods: {
    /* 接口调用-获取角色列表 */
    async getOrganizationList() {
      let url = '/api/v1/manage/inspector/organization'
      let data = await this.$axios.get(url)
      if (data && data.code == 1) {
        this.organizationList = data.data;
      }
    },

    /* 新增 */
    addFn() {
      this.form.organizationId = this.mixinUserInfo.organizationId;
      this.dialogVisible = true;
    },

    /* 保存 */
    async saveClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postFn();
        } else {
          this.$message.warning('请检查表单数据是否输入正确！');
          return false;
        }
      });
    },

    /* 提交 */
    async postFn() {
      this.loading = true;
      let url = '/api/v1/manage/ticket/storage';
      let params = this.$utils.deepCopyFn(this.form);
      params.remainingNum = this.remainingNum;
      params.storageNum = this.remainingNum;
      let data = await this.$axios.post(url, params);
      this.loading = false;
      if (data && data.code == 1) {
        this.dialogVisible = false;
        this.$message.success('保存成功！')
        this.$refs.customTable.listFn();
      }
    },

    /* 删除 */
    deleteClick(row) {
      let url = '/api/v1/manage/ticket/storage'
      this.$confirm('确认要删除该记录吗?', '删除提示').then(async () => {
        let data = await this.$axios.delete(url, { id: row.id })
        if (data && data.code == 1) {
          this.$message.success('删除成功')
          this.$refs.customTable.listFn()
        }
      })
    }
  }
}
</script>

